/* eslint-disable no-use-before-define */
import React from 'react'
import { getKey } from '@helpers/env'
import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES } from '@consts/index'
import { CollectionProduct as CollectionProductProps } from 'types/collection'
import CollectionProduct from '../CollectionProduct'
import styles from './styles.module.scss'

type CollectionProductListProps = {
  products: CollectionProductProps[]
  title: string
  showProductType: boolean
}

function CollectionProductList({
  products,
  showProductType,
  title
}: CollectionProductListProps) {
  const isTabletUp = useMediaQuery({
    minWidth: BREAKPOINT_SIZES.TABLET,
    initialState: false
  })

  return (
    <ul className={styles.productList__container}>
      {products.map(product => {
        return (
          <li
            key={getKey(product.id)}
            className="productList__item"
            data-testid={`productType-${product.product_type}`}
          >
            <CollectionProduct
              title={title}
              product={product}
              showProductType={showProductType}
              isTabletUp={isTabletUp}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default CollectionProductList
